export const getGrandTotal = (
  fabrics = [],
  accessories = [],
  items = [],
  styles = []
) => {
  return +(
    (fabrics || []).reduce((acc, item) => acc + (+item.total || 0), 0) +
    (accessories || []).reduce((acc, item) => acc + (+item.total || 0), 0) +
    (items || []).reduce((acc, item) => acc + (+item.total || 0), 0) +
    (styles || []).reduce((acc, item) => acc + (+item.total || 0), 0)
  ).toFixed(2);
};
